import { useNode } from '@craftjs/core';
import { Stack } from '@mui/material';

import { SelectInput } from '@/components/form/baseInputs/SelectInput/SelectInput';
import { TextInput } from '@/components/form/baseInputs/TextInput/TextInput';

import {
  EducationalSlideHeadingProps,
  HeadingVariant,
} from './EducationalSlideHeading';

const HEADING_SIZE_OPTIONS: { value: HeadingVariant; display: string }[] = [
  { value: 'h1', display: 'XL' },
  { value: 'h2', display: 'L' },
  { value: 'h3', display: 'M' },
  { value: 'h4', display: 'S' },
];

export function EducationalSlideHeadingSettings() {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as EducationalSlideHeadingProps,
  }));

  return (
    <Stack spacing={2}>
      <TextInput
        label="Title"
        name="title"
        value={props.title}
        onChange={(e) => {
          setProp((props: EducationalSlideHeadingProps) => {
            props.title = e.target.value;
          });
        }}
      />
      <SelectInput
        label="Size"
        name="variant"
        value={props.variant ?? 'h2'}
        onChange={(e) => {
          setProp((props: EducationalSlideHeadingProps) => {
            props.variant = e.target
              .value as EducationalSlideHeadingProps['variant'];
          });
        }}
        options={HEADING_SIZE_OPTIONS}
        showEmptyValue={false}
      />
    </Stack>
  );
}
